import * as api from "@/services/api";

export default async function getAvailableInvoicesForChat(dataIn) {
  const data = {
    buyerCompanyId: dataIn.buyerCompanyId,
    sellerCompanyId: dataIn.sellerCompanyId,
    requestorType: dataIn.requestorType,
    requestorCompanyId: dataIn.requestorCompanyId,
  };

  return api.post("company-chat/chat-invoices", data);
}
